import { PayloadAction } from '@reduxjs/toolkit';
import { FormatState } from 'src/store/format/types';

const setAvailableFormatsAreLoadedReducer = (state: FormatState, action: PayloadAction<boolean>) => {
  state.availableFormatsAreLoading = action.payload;
};

export default setAvailableFormatsAreLoadedReducer;
